import {Button, Card, Col, Form, Input, message, Modal, Radio, Row, Select, Space, Spin} from "antd";
import {SecondApplicantDetailDto} from "../../dto/SecondApplicantDetailDto";
import Validation from "../../util/Validation";
import {
    COMMON_DROPDOWN,
    EMAIL_MAX_LENGTH,
    EMAIL_VALIDATION,
    EXISTING_USER_ACCOUNT_CREATE_OPTION,
    IDENTIFICATION_SOURCE,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    NIC_VALIDATION,
    PARAMETER_LIST
} from "../../util/Constants";
import {useEffect, useState} from "react";
import {
    MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR,
    MSG_PLEASE_ENTER_A_VALID_EMAIL
} from "../../util/Messages";
import accountService from "../../service/accountService";
import ErrorHandler from "../../util/ErrorHandler";
import customerService from "../../service/customerService";
import {CustomerDto} from "../../dto/CustomerDto";
import {sec_applicant_screen} from '../../../AppImageConst';
import {JointAccountWrapperDto} from "../../dto/JointAccountWrapperDto";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {UsergroupAddOutlined} from "@ant-design/icons";
import './style.scss'
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {toLower} from "lodash";

const SecondApplicantData = () => {
    const [form] = Form.useForm();
    const [isCustomerExisting, setCustomerIsExisting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [filledData, setFilledData] = useState<JointAccountWrapperDto>({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [accountList, setAccountList] = useState<DropdownListDto[]>([]);
    const [accountCreationOption, setAccountCreationOption] = useState(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC);
    const [selectedAccNo, setSelectedAccNo] = useState("");

    const [dropdownDto, setDropdownDto] = useState<DropdownListDto | undefined>({label: "NIC", value: 1});
    const [identificationSourceTypeList, setIdentificationSourceTypeList] = useState<DropdownListDto[]>([]);
    useEffect(() => {
        loadIdentitySourceTypes()

    }, [])
    const onchangeIsExistingCustomer = (e: Event) => {
        const value = (e.target as HTMLInputElement).value as unknown as boolean;
        setCustomerIsExisting(value)
        resetFields()
        //reset dropdown back to nic
        setDropdownDto({label: "NIC", value: 1})
    }
    const submitDetail = (val: SecondApplicantDetailDto) => {
        form.validateFields().then(() => {

            const jointAccWrapperDto = {
                secondApplicantDetailDto: val,
                isNewAccount: "",
                accountNumber: "",
                cidNumber: "",
                preferredOption: ""
            } as JointAccountWrapperDto
            setFilledData(jointAccWrapperDto)
            setIsModalOpen(true)
        }).catch(() => {

        });

    }
    const handleCINEnter = (val: string) => {
        if (val !== "") {
            setIsLoading(true)
            customerService.getCustomerDateByCin(val).then(res => {
                setIsLoading(false)
                if (res.data.results.customerMstDto != null) {
                    const customerDto = res.data.results.customerMstDto as CustomerDto
                    form.setFieldsValue(
                        {
                            mobileNumber: customerDto.mobileNo,
                            email: customerDto.email,
                            name: customerDto.nameToAppearOnStatement,
                            identificationSourceId: customerDto.identificationSource?.id,
                            identificationSourceValue: customerDto.identificationValue
                        }
                    )
                    let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
                        return obj.value == customerDto.identificationSource?.id
                    });
                    setDropdownDto(dropdownListDto)
                }

            }, (reason) => {
                setIsLoading(false)
                resetFields()
                ErrorHandler.handleError(reason);
            })
        }

    }
    const loadAccList = () => {
        accountService.getAccountListByLoggedUsername().then(res => {
            console.log(res.data);
            setAccountList(res.data.results)
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const onChangeAccCreationOption = (e: Event) => {
        setAccountCreationOption(+(e.target as HTMLInputElement).value)
        if (+(e.target as HTMLInputElement).value === EXISTING_USER_ACCOUNT_CREATE_OPTION.ADD_SECOND_HOLDER_TO_EXISTING_ACC) {
            loadAccList();
        }
    }
    const onChangeAccNo = (val: string) => {
        setSelectedAccNo(val)
    }
    const handleOk = () => {
        setIsLoading(true)
        setIsModalOpen(false);
        let filled: JointAccountWrapperDto = filledData
        filled.isNewAccount = accountCreationOption === EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC
        filled.accountNumber = selectedAccNo
        filled.cidNumber = ""
        filled.preferredOption = accountCreationOption
        accountService.saveAccountDetailWithSecondApplicantData(filled).then(res => {
            setIsLoading(false)

            message.success("New joint account request submitted successfully").then(
                resetFields()
            )
        }, (reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        })
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        setAccountCreationOption(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC)
    };
    const resetFields = () => {
        form.resetFields(["cidNumber", "mobileNumber", "email", "name", "identificationSourceId",
            "identificationSourceValue"])
    }
    const loadIdentitySourceTypes = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.IDENTIFICATION_SOURCE,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setIdentificationSourceTypeList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const onChangeIdentificationType = (e: Event) => {
        form.setFieldsValue({identificationSourceValue: ''})
        let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
            return obj.value == e
        });
        setDropdownDto(dropdownListDto)
    };
    const getPlaceHolderByIdentificationType = (identificationType: string | undefined) => {
        if (undefined != identificationType) {
            return IDENTIFICATION_SOURCE.NIC === identificationType ? identificationType : toLower(identificationType)
        }
        return "N/A"
    }
    const onChangeSourceType = (e: Event) => {
        form.resetFields(["identificationSourceValue"])
        let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
            return obj.value == (e.target as HTMLInputElement).value
        });
        setDropdownDto(dropdownListDto)
    };

    const mobileNumberValidator = (_: any, value: any) => {
        const mobileNumberWithoutSpaces = value ? value.replace(/\s/g, '') : '';
        if (mobileNumberWithoutSpaces.length > MOBILE_NUMBER_MAX_LENGTH) {
            return Promise.reject('The maximum length is 15 numbers');
        } else if (mobileNumberWithoutSpaces.length < MOBILE_NUMBER_MIN_LENGTH) {
            return Promise.reject('Minimum of 7 characters are required');
        }
        return Promise.resolve();
    }
    return (
        <Spin spinning={isLoading}>
            <Row gutter={[40, 0]} className={'right-side-container-margin disabled-data-show-inputs-container'}>
                <Col lg={10} md={10} sm={0}
                     className={'left-side-main-container left-side-main-container-inside-dashboard'}>
                    <Row>
                        <Col span={24}>
                            <div className="clip-path-img">
                                <div className='clip-path-img-container'>
                                    <img src={sec_applicant_screen} alt="logo"/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col lg={14} md={14} sm={24}
                     className='right-side-main-container-inside-dashboard align-div-center layout-bottom-space dashboard-right-side-contaner-scroll'>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        onFinish={submitDetail}
                        form={form}
                    >
                        <div className='account_type_container second-applicant-details' style={{paddingTop: 16}}>
                            <div>
                                <Row gutter={[32, 0]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                                        <h2 className='page-header-main-title'>
                                            <div className='header_icon header-icon-center'>
                                                <UsergroupAddOutlined/>
                                            </div>
                                            Second Applicant Details
                                        </h2>
                                    </Col>
                                </Row>
                                <Card className={'template_card'}>
                                    <Row gutter={[32, 0]}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                label="Is the second applicant an existing customer?"
                                                name={"isExistingCustomer"}
                                                rules={
                                                    [{
                                                        required: true,
                                                        message: 'Please select whether the customer is existing'
                                                    }]}>
                                                <Radio.Group optionType="button"
                                                             buttonStyle="solid"
                                                             getPopupContainer={(trigger: {
                                                                 parentNode: any;
                                                             }) => trigger.parentNode}
                                                             onChange={onchangeIsExistingCustomer}
                                                >

                                                    <Radio.Button value={true}>Yes</Radio.Button>
                                                    <Radio.Button value={false}>No</Radio.Button>

                                                </Radio.Group>


                                                {/*<Select placeholder={"Select title"}*/}
                                                {/*        onChange={onchangeIsExistingCustomer}*/}
                                                {/*        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}*/}
                                                {/*        style={{width: '100%'}}*/}
                                                {/*        options={[{label: "No", value: false}, {label: "Yes", value: true}]}*/}
                                                {/*/>*/}
                                            </Form.Item>
                                        </Col>
                                        {
                                            isCustomerExisting ?
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label="CIN"
                                                        name={"cidNumber"}
                                                        onKeyPress={Validation.isNumberWithoutDot}
                                                        rules={[{required: true, message: 'Please enter CIN'}]}
                                                    >
                                                        <Input size={'large'}
                                                               onBlur={(e: any) => handleCINEnter(e.target.value)}
                                                               placeholder={"Enter CIN"}/>
                                                    </Form.Item>
                                                </Col> : ''
                                        }

                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                label="Name"
                                                name={"name"}
                                                onKeyPress={Validation.onlyAlphabeticWithSpaceAndDot}
                                                rules={[
                                                    {required: true, message: 'Please enter name'},
                                                    {whitespace: true, message: 'Cannot contain whitespaces'},
                                                    isCustomerExisting ? {} : {
                                                        max: 30,
                                                        message: 'The maximum length is 30 characters'
                                                    },
                                                ]}>
                                                <Input size={'large'} disabled={isCustomerExisting}
                                                       placeholder={"Enter name"}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                label="Email"
                                                name={"email"}
                                                rules={
                                                    [
                                                        {
                                                            required: true,
                                                            message: 'Please enter your email'
                                                        },
                                                        {
                                                            max: EMAIL_MAX_LENGTH,
                                                            message: 'The maximum length is 254 characters'
                                                        },
                                                        {
                                                            pattern: EMAIL_VALIDATION,
                                                            message: MSG_PLEASE_ENTER_A_VALID_EMAIL
                                                        },

                                                    ]}>
                                                <Input size={'large'} disabled={isCustomerExisting}
                                                       placeholder={"Enter email"}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                label={"Mobile Number"}
                                                name="mobileNumber"
                                                onKeyPress={Validation.isNumberWithoutDot}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter your mobile number'
                                                    },
                                                    !isCustomerExisting ? {validator: mobileNumberValidator} : {}
                                                ]}>
                                                <Input size={'large'} disabled={isCustomerExisting}
                                                       placeholder="Enter mobile number"/>
                                            </Form.Item>

                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                label="Identification Source"
                                                name={"identificationSourceId"}
                                                initialValue={1}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select identification source'
                                                    },
                                                ]}>


                                                <Radio.Group onChange={onChangeSourceType} disabled={isCustomerExisting}
                                                             defaultValue={dropdownDto?.value}>
                                                    {identificationSourceTypeList.map((data: DropdownListDto) => {
                                                        return <Radio value={data.value}>{data.label}</Radio>
                                                    })}
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                label={dropdownDto?.label.concat(" Number")}
                                                name="identificationSourceValue"
                                                onKeyPress={(dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? Validation.nicFieldValidation : Validation.isNumbersAndLetters}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter your '.concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")
                                                    },
                                                    (dropdownDto?.label !== IDENTIFICATION_SOURCE.NIC) ? {
                                                        max: 15,
                                                        message: 'The maximum length is 15 characters'
                                                    } : {},
                                                    (dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? {
                                                        pattern: NIC_VALIDATION,
                                                        message: "Please enter a valid NIC number"
                                                    } : {},
                                                ]}>
                                                <Input size="large" disabled={isCustomerExisting}
                                                       placeholder={"Enter your ".concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")}/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>

                            </div>
                            <div>
                                <Row gutter={[32, 0]}>
                                    {/*<Col lg={12} md={12} xl={12} sm={12} xs={12} className='back-btn-container'>*/}
                                    {/*    <Form.Item className='form-item-btn'>*/}
                                    {/*        <Button onClick={props.goBack} className='custom-back-btn-primary'*/}
                                    {/*                type="ghost">*/}
                                    {/*            Back*/}
                                    {/*        </Button>*/}
                                    {/*    </Form.Item>*/}
                                    {/*</Col>*/}
                                    <Col sm={24} lg={{span: 8, offset: 16}} className='continue-btn-col text-right'>
                                        <Form.Item className='form-item-btn'>
                                            <Button htmlType="submit" type="primary"
                                                    className='custom-btn-primary ant-btn margin_top_20'>
                                                Continue
                                            </Button>
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>

            <Modal title="Account Creation Option"
                   open={isModalOpen}
                   destroyOnClose={true}
                   maskClosable={false}
                   footer={null}
                   onCancel={handleCancel}
                   centered
                   className='dashboard-account-open-modal'
            >
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            onFinish={handleOk}
                        >
                            <h4 style={{marginTop: 8}}>Which of the following option do you
                                prefer?</h4>
                            <Form.Item
                                // label={<b>Which of the following option do you prefer?</b>}
                                style={{marginTop: 10, marginBottom: 10}}
                                // name={"preferredOption"}
                            >
                                <Radio.Group className='radio_group_set'
                                             onChange={onChangeAccCreationOption}
                                             defaultValue={EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC}
                                >
                                    <Space direction="vertical">

                                        <Radio radioSize={20} dotSize={16}
                                               value={EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC}>
                                            Start a new joint account</Radio>
                                        <Radio radioSize={20} dotSize={16}
                                               value={EXISTING_USER_ACCOUNT_CREATE_OPTION.ADD_SECOND_HOLDER_TO_EXISTING_ACC}>
                                            Add second holder to my existing account</Radio>
                                    </Space>
                                </Radio.Group>
                            </Form.Item>
                            {
                                accountCreationOption ===
                                EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC ?
                                    <div style={{marginBottom: 16}}>
                                    </div> : ''
                            }
                            {
                                accountCreationOption ===
                                EXISTING_USER_ACCOUNT_CREATE_OPTION.ADD_SECOND_HOLDER_TO_EXISTING_ACC ?
                                    <Form.Item
                                        style={{marginTop: 10}}
                                        label="Select Account Number"
                                        onKeyPress={Validation.isNumbersAndLetters}
                                        name={"referenceNumber"}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select account number'
                                            }]}>

                                        <Select onChange={(e: string) => onChangeAccNo(e)}
                                                size={'large'}
                                                placeholder="Select account number"
                                                options={accountList}/>

                                    </Form.Item> : ''
                            }
                            <Row className='modal-btn-row'>
                                <Col span={24}>
                                    <Space style={{float: 'right'}}>
                                        <Button onClick={handleCancel} className='cancel-btn'>
                                            Cancel
                                        </Button>
                                        <Form.Item>
                                            <Button htmlType="submit" className='submit-btn'
                                                    type="primary">
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>

            </Modal>


        </Spin>
    )

}
export default SecondApplicantData;

